import { Variables } from "../../../Variations/Variations";
import Cookies from "js-cookie";
import { withLoader } from "../../../Services/ApiClient";

const getAuthHeaders = () => {
  const token = Cookies.get("UserToken");
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: token ? `Bearer ${token}` : "",
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    const text = await response.text();
    throw text || "Request failed";
  }

  if (response.status === 204) return null;

  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

export const SlideService = {
  getPaged: (page, pageSize, search = "") =>
    withLoader(
      fetch(
        `${Variables.API_URL}Slide/GetSlidesPaged?page=${page}&pageSize=${pageSize}&search=${encodeURIComponent(search)}`,
        { headers: getAuthHeaders() }
      ).then(handleResponse)
    ),

  getAll: () =>
    withLoader(
      fetch(`${Variables.API_URL}Slide/GetSlides`, {
        headers: getAuthHeaders(),
      }).then(handleResponse)
    ),

  getById: (id) =>
    withLoader(
      fetch(`${Variables.API_URL}Slide/GetSlide/${id}`, {
        headers: getAuthHeaders(),
      }).then(handleResponse)
    ),

  create: (payload) =>
    withLoader(
      fetch(`${Variables.API_URL}Slide/AddSlide`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      }).then(handleResponse)
    ),

  update: (id, payload) =>
    withLoader(
      fetch(`${Variables.API_URL}Slide/UpdateSlide/${id}`, {
        method: "POST",
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      }).then(handleResponse)
    ),

  togglePublish: (id) =>
    withLoader(
      fetch(`${Variables.API_URL}Slide/TooglePublishSlide/${id}`, {
        method: "POST",
        headers: getAuthHeaders(),
      }).then(handleResponse)
    ),

  getSliders: () =>
    withLoader(
      fetch(`${Variables.API_URL}Slider/GetSliders`, {
        headers: getAuthHeaders(),
      }).then(handleResponse)
    ),

  getAssignedSliders: (slideId) =>
    withLoader(
      fetch(
        `${Variables.API_URL}Slide/GetAssignedSliders/${slideId}`,
        { headers: getAuthHeaders() }
      ).then(handleResponse)
    ),

  assignSliders: (slideId, sliders) =>
    withLoader(
      fetch(
        `${Variables.API_URL}Slide/AssignSlidersToSlide/${slideId}`,
        {
          method: "POST",
          headers: getAuthHeaders(),
          body: JSON.stringify(
            sliders.map((s) => ({
              SlideID: slideId,
              SliderId: s.SliderId,
            }))
          ),
        }
      ).then(handleResponse)
    ),
};
